import { appEventEmitter } from "@shared/events/app-event-emitter";
import { datadogService } from "@shared/services/datadog/datadog-service";
import { useCallback, useEffect } from "react";

export const useDatadogEventTracking = () => {
  const datadogRumListener = useCallback((_: any, eventType: string) => {
    switch (eventType) {
      case "login":
        datadogService.setUser();
        break;
      case "logout":
        datadogService.clearUser();
        break;
      default:
        {
          const datadogUser = datadogService.getDatadogUser();
          if (!datadogUser) {
            datadogService.setUser();
          }
        }
        break;
    }
  }, []);

  useEffect(() => {
    appEventEmitter.addGlobalListener(datadogRumListener);
    return () => {
      appEventEmitter.removeGlobalListener(datadogRumListener);
    };
  }, [datadogRumListener]);
};
